import styled from "styled-components";

export const ConfettiStripsSvgBox = styled.svg<{startCoordinates?: {top: number; left: number;}}>`
    /* Position it at the center of the container if no start coordinates are given */
    position: absolute;
    top: ${({startCoordinates}) => startCoordinates ? (startCoordinates.top + "px") : "50%"};
    left: ${({startCoordinates}) => startCoordinates ? (startCoordinates.left + "px") : "50%"};
    /* Make it visible, at the end of the animation it will be fully transparent */
    opacity: 1;

    @media ${({theme}) => theme.mediaQuery.landscape} {
        width: 100vw;
        max-width: 768px;
        /** Apparently, in this svg the center of the animation is not the center of the rectangle, is a bit to the left. So I use 42% instead of 50% */
        transform: translate(-42%, -50%);
    }
    /** In portrait, I want the svg to be oriented accordingly. width becomes height, x swaps with y */
    @media ${({theme}) => theme.mediaQuery.portrait} {
        height: 100vw;
        max-height: 768px;
        transform: translate(-50%, -42%) rotate(90deg);
    }
`;